import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Popper from '@mui/material/Popper';

import { ChromePicker } from 'react-color'

import Bs4GenericField from './Bs4GenericField';

export default class Bs4Color extends Bs4GenericField {
  
  intToHex = (c) => {
    var hex = c.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  }

  rgbaToHex(rgba) {   
    console.log('... RGBA ...', rgba) 
    try {
      return "#" + this.intToHex(rgba.r) + this.intToHex(rgba.g) + this.intToHex(rgba.b) + this.intToHex(parseInt(255 * rgba.a));
    } catch(error) {
      return '#000000ff';
    }
  }

  setOpen = (open) => {}

  ViewComponentField = (props) => {
    const formField = this;
    const theme = useTheme();
    const [value, setValue] = React.useState(this.getValue() || '#ffffff');
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR)
    this.refFocus = React.useRef();  
    const [open, setOpen] = React.useState(false);
    
    React.useEffect(() => {
      this.notValidElementDom = (text) => {setError({error: true, helperText: text})}
      this.setOpen = (open) => {
        setOpen(open);
        this.trigger(Bs4GenericField.OPEN_POPUP_VIEW, this, open);
      }

      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        setValue(this.getValue());
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      })
    }, [error]);

    const handleChangeColor = (color) => {
      //const hex = this.rgbaToHex(color.rgb);
      try {
        color = color.rgb;
        const c = `rgba(${color?.r}, ${color?.g}, ${color?.b}, ${color?.a})`
        color = c;
      } catch(error) {
        console.log(error)
        color = '#000000ff'
      }
      setValue(color)
    };

    const handleChangeComplete = (color) => {
      //const hex = this.rgbaToHex(color.rgb);
      try {
        color = color.rgb;
        const c = `rgba(${color?.r}, ${color?.g}, ${color?.b}, ${color?.a})`
        color = c;
      } catch(error) {
        console.log(error)
        color = '#000000ff'
      }
      this.setValue(color)
    };

    const handleClick = (event) => {
      setOpen(!open);
    }
    
    const sxBox = {
      backgroundImage: 'linear-gradient(45deg, #dddddd 25%, transparent 25%), linear-gradient(-45deg, #dddddd 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #dddddd 75%), linear-gradient(-45deg, transparent 75%, #dddddd 75%)',
      backgroundSize: '20px 20px',
      backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px',
      borderRadius: theme.shape.borderRadius+'px',
      width: '100%',
      height: '30px',
      overflow: 'hidden',
      border: 'solid', 
      borderWidth: '1px',
      borderColor: '#dddddd',
    }

    return (           
      <FormControl id={formField.getElementId()} fullWidth error={error.error} >
        {!formField.props?.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
        <Box ref={formField.refFocus} sx={sxBox} onClick={handleClick}> 
          <Box height='100%' width='100%' backgroundColor={value}/>
        </Box>
        <FormHelperText>{error.helperText}</FormHelperText>
        <Popper          
          sx={{zIndex: theme.zIndex.modal}}
          open={open}
          anchorEl={formField.refFocus.current}
          placement="bottom" //"bottom-start"
        >
          <ChromePicker color={value} onChange={handleChangeColor} onChangeComplete={handleChangeComplete}/>
        </Popper>        
      </FormControl>      
    );
  }
}